export const SHADOW_STYLE_CARD = ":host .container .footer { border-top: 1px solid #d1d1d1;​​ border-top: 1px solid #d1d1d1; padding: 0.75rem; }​​";
export const SHADOW_STYLE_NAVBAR = "section { border-top: none !important; }";

let ddStyle = `:host .container::before { content: "" }​`;
ddStyle += " .container { padding: 0.75rem 0.75rem 0.75rem 2rem !important; }";
ddStyle += " .container { padding: 0.75rem 0.75rem 0.75rem 2rem !important; }";
ddStyle += " .container { padding: 0.75rem 0.75rem 0.75rem 2rem !important; }";
export const SHADOW_STYLE_DROPDOWN = ddStyle;

let modalStyle  = "div.modal { background-color: rgba(0, 0, 0, .46) !important; }";
modalStyle += " div.header, div.content, div.footer { background-color: transparent !important; border-top: none !important; border-bottom: none !important; }";
modalStyle += " button.close { color: white !important; } button.close:hover { background-color: grey !important; }";
export const SHADOW_STYLE_PREVIEW_MODAL = modalStyle;